var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._l((5),function(n){return _c('v-row',{key:n},[_c('v-checkbox',{attrs:{"value":n,"label":_vm.research_area_names[n],"dense":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }